import React from 'react';

const WidgetMessagesInterServicesSvg = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38 34" fill="none">
        <path d="M2 5.66699H36V29.7503H2V5.66699Z" stroke={couleur} strokeWidth="4"
              strokeLinejoin="round"/>
        <path d="M4.15137 5.66699H33.9381L19.0001 21.2503L4.15137 5.66699Z" stroke={couleur}
              strokeWidth="4" strokeLinejoin="round"/>
    </svg>
);

export default WidgetMessagesInterServicesSvg;
